// Guards shared by every Date of Service (DOS) field.
//
// A DOS describes care that already happened, so a future date is never valid:
// not picked from the calendar, not typed, not pasted.

// Deliberately looser than the MM/DD/YYYY validation pattern so out-of-range
// years (3000, 2100, ...) are still recognized as complete dates and blocked.
const COMPLETE_DATE_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

export const FUTURE_DATE_MESSAGE = 'Date of Service cannot be in the future.';

/** Parses a complete MM/DD/YYYY value. Returns null for partial or invalid input. */
export const parseMdyDate = (value: string): Date | null => {
  const match = COMPLETE_DATE_PATTERN.exec((value || '').trim());
  if (!match) return null;
  const month = Number(match[1]);
  const day = Number(match[2]);
  const year = Number(match[3]);
  const date = new Date(year, month - 1, day);
  // Rejects rolled-over dates such as 02/31/2020.
  if (isNaN(date.getTime()) || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }
  return date;
};

/**
 * True only once a value spells out a complete date that lands after today.
 * Partial input ("09/09/20") stays allowed so a date can still be typed.
 */
export const isFutureDateString = (value: string): boolean => {
  const date = parseMdyDate(value);
  if (!date) return false;
  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);
  return date > endOfToday;
};
